// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"828b169a","453":"589e1ce1","667":"1b3dd7ba"}[chunkId] + ".chunk.js";
};